import React ,{ JSX, useState, useEffect } from 'react';
import { viewportMultiItem } from '../../utils/utils';
import Carousel from 'react-multi-carousel';
// NOTE: The consuming application should import 'react-multi-carousel/lib/styles.css' in their _app.js or global styles
// Do not import global CSS in library components to avoid Next.js conflicts

const DeviceCarouselComponent = (props: any): JSX.Element => {
  const responsive: any = {
    desktopLarge: {
      breakpoint: { max: 7000, min: 1440 },
      items: 4,
      slidesToSlide: 3
    },
    desktop: {
      breakpoint: { max: 1439, min: 1024 },
      items: 3,
      slidesToSlide: 3
    },
    tabletMedium: {
      breakpoint: { max: 1023, min: 768 },
      items: 2,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      partialVisibilityGutter: 40,
    },
  };

  // Use isMounted to avoid any SSR/client mismatch for viewport-dependent props
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => { setIsMounted(true); }, []);

  const viewPort = viewportMultiItem();
  // Only compute viewport-dependent props after mount (client-only)
  const showDots = isMounted && props?.children?.length > responsive?.[viewPort]?.items;
  const showArrows = isMounted ? viewPort !== 'mobile' : false;

  return (
    <Carousel
      responsive={responsive}
      renderButtonGroupOutside={true}
      partialVisible={true}
      swipeable={true}
      autoPlay={false}
      shouldResetAutoplay={false}
      arrows={showArrows}
      showDots={showDots}
    >
      {props.children}
    </Carousel>
  );
};

export default DeviceCarouselComponent;
